export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  date: string;
  author: string;
  image: string;
  tags: string[];
  relatedSlugs: string[];
}

export const articles: Article[] = [
  {
    id: 'article-1',
    slug: 'kaiyun-2024-security-upgrade',
    title: '开云平台完成2024年度安全体系全面升级',
    excerpt: '为进一步提升用户安全保障水平，开云平台近期完成了安全体系的全面升级，引入了新一代智能风控系统与多重验证机制，全方位守护用户信息安全。',
    content: `<p>为进一步提升用户安全保障水平，开云平台近期完成了安全体系的全面升级。本次升级涵盖了账户安全、数据传输、隐私保护等多个维度，旨在为用户打造一个更加安全可靠的服务环境。</p>
    <h2>新一代智能风控系统</h2>
    <p>开云平台全新部署的智能风控系统，基于深度学习算法和大数据分析技术，能够实时监测和分析用户行为模式。系统可在毫秒级别识别异常操作，自动触发安全验证流程，有效防范盗号、欺诈等安全风险。</p>
    <p>该系统具备自适应学习能力，能够根据新型威胁模式不断优化识别算法，确保安全防护始终处于行业领先水平。自系统上线以来，已成功拦截超过十万次潜在安全威胁。</p>
    <h2>多重验证机制升级</h2>
    <p>在原有密码登录的基础上，开云平台新增了多种身份验证方式，包括短信动态验证码、生物特征识别、设备指纹验证等。用户可根据自身需求灵活选择验证组合，在便捷性和安全性之间取得最佳平衡。</p>
    <p>特别地，针对高风险操作（如修改密码、更换绑定手机等），系统将强制启用双重验证，确保关键操作的绝对安全。</p>
    <h2>数据加密传输全面强化</h2>
    <p>开云平台已全面升级至最新的TLS 1.3加密传输协议，所有用户数据在传输过程中均经过高强度加密处理。同时，平台对存储的敏感数据采用分层加密策略，即使面对极端情况，也能最大程度保障用户信息安全。</p>
    <h2>定期安全审计制度</h2>
    <p>开云平台建立了严格的安全审计制度，定期邀请第三方权威安全机构进行全面的渗透测试和安全评估。所有发现的潜在风险均会在第一时间得到修复，确保平台安全防护体系始终无懈可击。</p>
    <p>开云平台始终将用户安全置于首位，未来我们将持续加大在安全领域的投入，以技术创新驱动安全升级，守护每一位用户的信任。</p>`,
    category: '平台动态',
    date: '2024-12-15',
    author: '开云安全团队',
    image: 'https://readdy.ai/api/search-image?query=Modern%20corporate%20security%20center%20with%20warm%20amber%20lighting%2C%20futuristic%20dashboard%20screens%20displaying%20data%2C%20clean%20minimalist%20office%20design%2C%20professional%20atmosphere%20with%20dark%20surfaces%20and%20golden%20accents%2C%20sophisticated%20tech%20environment&width=800&height=500&seq=kaiyun-news-01&orientation=landscape',
    tags: ['安全升级', '智能风控', '数据加密', '平台动态'],
    relatedSlugs: ['kaiyun-new-service-launch', 'kaiyun-user-conference-2024'],
  },
  {
    id: 'article-2',
    slug: 'kaiyun-new-service-launch',
    title: '开云平台推出全新智能推荐服务，个性化体验再升级',
    excerpt: '基于深度学习算法的智能推荐系统正式上线，通过对用户行为偏好的精准分析，为每位用户提供量身定制的服务推荐。',
    content: `<p>开云平台今日宣布，基于深度学习算法的智能推荐系统正式上线运行。这一系统通过对海量用户行为数据的深度分析，能够精准捕捉每位用户的独特偏好，从而提供高度个性化的服务推荐。</p>
    <h2>技术核心：深度学习算法</h2>
    <p>开云智能推荐系统采用了业界领先的深度学习模型，结合协同过滤、内容推荐、知识图谱等多种算法策略，构建了多层次的推荐架构。系统不仅关注用户的显性行为（如点击、收藏），更能洞察用户的隐性偏好。</p>
    <p>经过数月的内部测试和优化，推荐系统的准确率相比传统算法提升了约35%，用户满意度显著提高。</p>
    <h2>个性化体验升级</h2>
    <p>新系统上线后，每位用户将获得专属的个性化首页。系统会根据用户的兴趣领域、使用习惯和时间偏好，动态调整内容展示顺序和推荐的优先级，确保用户总能第一时间看到最感兴趣的内容。</p>
    <p>同时，系统支持实时学习，能够根据用户最新的行为反馈快速调整推荐策略，让推荐越来越贴合用户的真实需求。</p>
    <h2>隐私保护与数据安全</h2>
    <p>开云平台承诺，智能推荐系统在运行过程中严格遵循数据最小化原则，仅收集和分析必要的用户行为数据。所有数据均经过脱敏处理，用户的个人隐私得到充分保护。</p>
    <p>用户也可以在设置中随时调整个性化推荐的开放程度，甚至选择关闭个性化推荐功能，开云平台尊重每一位用户的选择权。</p>
    <h2>未来展望</h2>
    <p>智能推荐系统的上线只是开云平台AI战略的第一步。未来，我们将持续探索人工智能在更多业务场景中的应用，以技术创新驱动服务升级，为用户创造更加智能、便捷的数字体验。</p>`,
    category: '产品服务',
    date: '2024-11-28',
    author: '开云产品团队',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20modern%20product%20launch%20event%20scene%20with%20warm%20golden%20lighting%20and%20dark%20sophisticated%20backdrops%2C%20minimalist%20stage%20design%20with%20soft%20amber%20glow%2C%20premium%20corporate%20event%20atmosphere%2C%20clean%20geometric%20composition&width=800&height=500&seq=kaiyun-news-02&orientation=landscape',
    tags: ['智能推荐', 'AI技术', '个性化', '产品升级'],
    relatedSlugs: ['kaiyun-2024-security-upgrade', 'kaiyun-social-responsibility'],
  },
  {
    id: 'article-3',
    slug: 'kaiyun-user-conference-2024',
    title: '2024开云用户大会圆满落幕，共绘未来发展蓝图',
    excerpt: '以"连接·共创·未来"为主题的2024开云用户大会于近日成功举办，来自全国各地的用户代表齐聚一堂，共话平台发展。',
    content: `<p>以"连接·共创·未来"为主题的2024开云用户大会于近日在深圳成功举办。本次大会汇聚了来自全国各地的数百位用户代表、行业专家和合作伙伴，共同回顾过去一年的发展成就，展望未来的战略蓝图。</p>
    <h2>大会精彩回顾</h2>
    <p>大会开幕式上，开云平台首席执行官发表主旨演讲，回顾了平台在过去一年取得的重要成果——用户规模突破500万、服务覆盖扩展至全国300+城市、平台稳定运行时间达到99.99%等多项里程碑。</p>
    <p>随后，各业务线负责人分别就产品创新、技术升级、服务优化等主题进行了深入分享，展示了开云平台在各个领域的创新实践和未来规划。</p>
    <h2>用户之声：圆桌论坛</h2>
    <p>本次大会特别设置了"用户之声"圆桌论坛，邀请了来自不同行业、不同使用年限的用户代表，围绕产品体验、服务期望、社区建设等话题展开深度对话。</p>
    <p>一位来自上海的用户代表分享道："使用开云平台三年多来，我见证了平台的持续进化。从最初的基础功能到现在的智能化体验，开云始终在倾听用户的声音，这正是我最认可的地方。"</p>
    <h2>未来战略发布</h2>
    <p>大会的重磅环节——未来战略发布中，开云平台公布了下一阶段的三大战略方向：AI全面赋能、生态开放共赢、全球化布局。其中，AI全面赋能将成为最核心的战略支点，驱动所有业务线的智能化升级。</p>
    <h2>感恩回馈</h2>
    <p>为感谢广大用户长期以来的支持，大会现场宣布了一系列用户回馈计划，包括会员权益升级、专属福利发放等，引发了现场用户的热烈反响。</p>
    <p>开云平台将以此次大会为新的起点，继续秉持"用户至上"的理念，以技术创新和优质服务回馈每一位用户的信任与支持。</p>`,
    category: '新闻资讯',
    date: '2024-11-10',
    author: '开云公关团队',
    image: 'https://readdy.ai/api/search-image?query=Grand%20modern%20conference%20hall%20with%20warm%20golden%20chandelier%20lighting%2C%20large%20audience%20in%20elegant%20seating%2C%20professional%20stage%20with%20large%20display%20screens%2C%20sophisticated%20corporate%20event%20design%20with%20dark%20and%20amber%20color%20scheme&width=800&height=500&seq=kaiyun-news-03&orientation=landscape',
    tags: ['用户大会', '战略发布', '品牌活动', '社区建设'],
    relatedSlugs: ['kaiyun-social-responsibility', 'kaiyun-2024-security-upgrade'],
  },
  {
    id: 'article-4',
    slug: 'kaiyun-social-responsibility',
    title: '开云平台发布年度社会责任报告，践行企业担当',
    excerpt: '开云平台正式发布2024年度社会责任报告，全面回顾了过去一年在公益慈善、绿色环保、社区共建等方面的工作成果。',
    content: `<p>开云平台今日正式发布2024年度社会责任报告，全面回顾了过去一年在公益慈善、绿色环保、社区共建、员工发展等多个维度的工作成果与实践经验。</p>
    <h2>公益慈善：用心传递温暖</h2>
    <p>2024年，开云平台在教育助学、乡村振兴、灾害救助等领域累计投入超过2000万元。其中，"云助学"公益项目已覆盖全国12个省份的50余所乡村学校，惠及超过10000名学生。</p>
    <p>此外，开云平台员工志愿服务总时长超过5000小时，以实际行动践行企业公民的责任担当。</p>
    <h2>绿色环保：科技赋能可持续发展</h2>
    <p>开云平台积极响应国家"双碳"目标，通过数据中心节能改造、绿色办公、碳抵消等举措，全年减少碳排放约3500吨。平台的数据中心PUE值已优化至1.3以下，处于行业领先水平。</p>
    <p>我们还推出了"绿色积分"计划，鼓励用户参与环保行动，已有超过50万用户加入这一绿色倡议。</p>
    <h2>社区共建：构建数字生态共同体</h2>
    <p>开云平台致力于构建健康、积极的数字社区生态。过去一年中，我们持续完善社区治理机制，引入AI内容审核系统，有效净化了社区环境。同时，平台举办了200余场线上线下社区活动，参与用户超过百万人次。</p>
    <h2>展望未来</h2>
    <p>企业社会责任不是一次性的行动，而是融入血脉的长期承诺。开云平台将继续以"科技向善"为指引，将社会责任融入企业战略和日常运营，与社会各界携手共创美好未来。</p>`,
    category: '平台动态',
    date: '2024-10-22',
    author: '开云CSR团队',
    image: 'https://readdy.ai/api/search-image?query=Modern%20corporate%20social%20responsibility%20scene%20with%20warm%20natural%20sunlight%2C%20green%20sustainable%20office%20environment%2C%20team%20of%20professionals%20collaborating%2C%20clean%20minimalist%20design%20with%20plants%20and%20warm%20wood%20textures%2C%20positive%20optimistic%20atmosphere&width=800&height=500&seq=kaiyun-news-04&orientation=landscape',
    tags: ['社会责任', '公益慈善', '绿色环保', 'ESG'],
    relatedSlugs: ['kaiyun-user-conference-2024', 'kaiyun-new-service-launch'],
  },
];

export const allNewsCategories = ['全部', '平台动态', '产品服务', '新闻资讯'];